import { Injectable } from '@angular/core';
import { UpdateFormValue } from '@ngxs/form-plugin';
import { Action, Selector, State, StateContext, Store } from '@ngxs/store';
import { RootState } from '../store/root.state';
import { AcademicYearStateModel } from './academic-year-state.model';
import { AcademicYearActions } from './academic-year.actions';
import { DotNetDatePipe } from '../pipes/dot-net-date.pipe';

@State<AcademicYearStateModel>({
	name: 'academicYearState',
	defaults: {
		academicYearForm: {
			model: {
				academicYearId: null
			}
		}
	} as AcademicYearStateModel
})
@Injectable()
export class AcademicYearState {
	constructor(
		private dotNetDatePipe: DotNetDatePipe,
		private store: Store
	) {}

	@Selector()
	static selectedYear(state: any): number {
		return state.academicYearForm.model.academicYearId;
	}

	@Action(AcademicYearActions.SetDefaultYear)
	setDefaultYear(ctx: StateContext<AcademicYearStateModel>, action: AcademicYearActions.SetDefaultYear) {
		const today = new Date();
		const content = this.store.selectSnapshot(RootState.content);

		const nextYear = content.nextAcademicYear;
		const currentYear = content.currentAcademicYear;

		let defaultYear: number | null = null;

		const currentOEBeginDate = this.dotNetDatePipe.transform(content.currentOpenEnrollmentBeginDate);
		const lastDayOfSchool = this.dotNetDatePipe.transform(content.currentLastDayOfSchool);

		if (today > lastDayOfSchool) {
			// After the last day of school, promote to next academic year
			defaultYear = nextYear;
		} else if (currentOEBeginDate == null || today < currentOEBeginDate) {
			// Before school starts (new school or before open enrollment), default to current year
			defaultYear = currentYear;
		}

		// Override logic
		if (action.isEnrollOverrideNextAY) {
			defaultYear = currentYear;
		} else if (action.isEnrollOverrideCurrentAY) {
			defaultYear = nextYear;
		}

		ctx.dispatch(
			new UpdateFormValue({
				value: { academicYearId: defaultYear },
				path: 'academicYearState.academicYearForm'
			})
		);
	}
}
